import React from 'react';
import PropTypes from 'prop-types';

import ALink from 'tradera/components/alink/alink';

const MenuItemButton = ({
    className,
    containerClass,
    follow,
    gaAttributes,
    inSPA,
    label,
    link,
    onClick
}) => {
    return (
        <li className={containerClass}>
            <ALink
                className={`btn btn-outline-dark d-flex justify-content-center align-items-center ${className}`}
                href={link}
                useLink={inSPA}
                onClick={onClick}
                {...(!follow && { rel: 'nofollow' })}
                {...gaAttributes}>
                <span className="text-truncate mr-2 flex-shrink-1">
                    {label}
                </span>
                <span className="flex-grow-0 flex-shrink-0">—&gt;</span>
            </ALink>
        </li>
    );
};

MenuItemButton.defaultProps = {
    className: '',
    containerClass: 'site-dropdown__item-default',
    follow: true
};

MenuItemButton.propTypes = {
    notify: PropTypes.number,
    link: PropTypes.string,
    bold: PropTypes.bool,
    border: PropTypes.bool,
    label: PropTypes.node,
    gaAttributes: PropTypes.object
};

export default MenuItemButton;
